import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import placeholderImg from '@/assets/Severe_Fire_Danger_Index.png'
import { LAYER_ATTRIBUTIONS } from '@/constants/layers/attributions'
import type { LayerInfo } from '@/types/LayerInfo'

// Shared by the legend and the info popup
const legendItems = [
  {
    text: {
      'en-US': 'Low',
      'es-ES': 'Bajo',
      'pt-BR': 'Baixo',
      'fr-FR': 'Bas'
    },
    color: '#2b83ba',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': 'Moderate',
      'es-ES': 'Moderado',
      'pt-BR': 'Moderado',
      'fr-FR': 'Modéré'
    },
    color: '#abdda4',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': 'High',
      'es-ES': 'Alto',
      'pt-BR': 'Alto',
      'fr-FR': 'Élevé'
    },
    color: '#ffffbf',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': 'Very High',
      'es-ES': 'Muy Alto',
      'pt-BR': 'Muito Alto',
      'fr-FR': 'Très élevé'
    },
    color: '#fdae61',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': 'Severe',
      'es-ES': 'Severo',
      'pt-BR': 'Severo',
      'fr-FR': 'Sévère'
    },
    color: '#d7191c',
    icon: 'mdi-square'
  }
]

// Description pending review by Matt Jolly (D2208-482)
const info: LayerInfo = {
  description: {
    'en-US':
      'Daily Severe Fire Danger Index (SFDI) forecast for North Africa. SFDI combines the ERC and BI percentiles and represents the potential for severe fire weather based on historical conditions.',
    'es-ES':
      'Pronóstico diario del Índice de Peligro de Incendio Grave (SFDI) para el norte de África. El SFDI combina los percentiles de ERC y BI y representa el potencial de condiciones meteorológicas de incendio graves según las condiciones históricas.',
    'pt-BR':
      'Previsão diária do Índice de Perigo de Incêndio Grave (SFDI) para o Norte da África. O SFDI combina os percentis de ERC e BI e representa o potencial de condições meteorológicas de incêndio graves com base nas condições históricas.',
    'fr-FR':
      "Prévision quotidienne de l'indice de danger d'incendie grave (SFDI) pour l'Afrique du Nord. Le SFDI combine les percentiles de l'ERC et du BI et représente le potentiel de conditions météorologiques propices aux incendies graves d'après les conditions historiques."
  },
  categories: legendItems,
  credit: LAYER_ATTRIBUTIONS.usfsFireLab,
  sourceUrl: 'https://www.wfas.net/'
}

export const fireDangerNorthAfrica: LayerRaw = {
  id: 'FireDanger',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  extraArcgisParameter: { copyright: info.credit },
  title: {
    'en-US': 'Severe Fire Danger Index (SFDI)',
    'pt-BR': 'Índice de Perigo de Incêndio Grave (SFDI)',
    'es-ES': 'Índice de Peligro de Incendio Grave (SFDI)',
    'fr-FR': "Indice de danger d'incendie grave (SFDI)"
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  opacity: 0.5,
  customProperties: { group: 'riskLayers', img: placeholderImg, info },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'naf:sfdiperc',
      visible: true,
      legend: {
        title: {
          'en-US': 'Severe Fire Danger Index (SFDI)',
          'pt-BR': 'Índice de Perigo de Incêndio Grave (SFDI)',
          'es-ES': 'Índice de Peligro de Incendio Grave (SFDI)',
          'fr-FR': "Indice de danger d'incendie grave (SFDI)"
        },
        items: legendItems
      }
    }
  ],
  icon: 'mdi-barley'
}
